import { apiClient, getData } from '@/api/client'
import { hasCode } from '@/api/errors'
import { chartOverlaysSchema, type ChartOverlays } from '@/schemas/signal-overlays'

/** mm-be's answer for a symbol it has no signals store for. */
const SYMBOL_NOT_FOUND = 'SIGNALS_SYMBOL_NOT_FOUND'

/**
 * A candle chart's layers, a seam of its own beside `signalsService`: one
 * read, JWT and the Signals add-on as every signals read
 * (`SharkSignalRequired`).
 */
export const overlaysService = {
  /**
   * Support, resistance, green/red markers and candle patterns for one
   * symbol, over its last `sessions` sessions (mm-be: 1–1,260, default 250).
   * The dashboard asks for NEPSE, the Signal page for its stock. A symbol
   * mm-be does not list (404 `SIGNALS_SYMBOL_NOT_FOUND`) has nothing on
   * record, which is how mm-be answers a listed symbol with no prices too:
   * empty lists and no window, so each pressed chip says it has nothing to
   * draw rather than offering a "Try again" that would get the same 404.
   */
  chartOverlays: async (symbol: string, sessions: number): Promise<ChartOverlays> => {
    try {
      const data = await getData<unknown>(() =>
        apiClient.GET('/api/v5/signals/chart-overlays/', {
          params: { query: { symbol, sessions } },
        }),
      )
      return chartOverlaysSchema.parse(data)
    } catch (error) {
      if (!hasCode(error, SYMBOL_NOT_FOUND)) throw error
      return {
        symbol,
        start: null,
        end: null,
        levelsDate: null,
        support: [],
        resistance: [],
        markers: [],
        patterns: [],
      }
    }
  },
}
